<script>

import { mapGetters, mapState } from 'vuex';

const Flavors = {
  accountSettings: 'account-settings',
  subscriptionType: 'subscription-type',
  creditCard: 'credit-card',
  signupOffering: 'signup-offering',
  signup: 'signup',
  signupTimeline: 'signup-timeline',
  webOnly: 'web-only',
  applePromotion: 'apple-promotion',
};

export default {
  name: 'BenefitMixin',
  computed: {
    ...mapState('benefits', ['benefitType', 'benefitAmount', 'benefitPercentage', 'redeemed']),
    ...mapGetters('benefits', ['BENEFIT_TYPES', 'discountedPrice', 'monthsText']),
    isGenericFreeMonthBenefit() {
      return this.benefitType === this.BENEFIT_TYPES.FREE_MONTHS && !this.redeemed;
    },
    isPercentageDiscountBenefit() {
      return this.benefitType === this.BENEFIT_TYPES.PERCENTAGE_DISCOUNT && !this.redeemed;
    },
    benefitSpecificText() {
      if (this.isPercentageDiscountBenefit && this.discountedPrice) {
        return `${this.monthString} ב־${this.benefitPercentage}% הנחה (${this.discountedPrice} ₪)`;
      }
      return this.monthString;
    },
    applePromotionText() {
      return `מגיעה לך הטבה של ${this.numberOfMonthString} בחינם`;
    },
    monthString() {
      if (this.benefitAmount === 1) {
        return 'חודש ראשון';
      }
      if (this.benefitAmount === 2) {
        return 'חודשיים ראשונים';
      }
      return `${this.benefitAmount} חודשים ראשונים`;
    },
    numberOfMonthString() {
      if (this.benefitAmount === 1) {
        return 'חודש אחד';
      }
      if (this.benefitAmount === 2) {
        return 'חודשיים';
      }
      return `${this.benefitAmount} חודשים`;
    },
    moreMonthsString() {
      if (this.benefitAmount === 1) {
        return 'חודש נוסף';
      }
      if (this.benefitAmount === 2) {
        return 'חודשיים נוספים';
      }
      return `${this.benefitAmount} חודשים נוספים`;
    },
    percentageBenefitSignupOfferingText() {
      const monthsText = (this.benefitAmount === 1) ? 'חודש ראשון' : `${this.benefitAmount}  חודשים ראשונים`;
      const priceText = this.discountedPrice ? ` (${this.discountedPrice} ₪)` : '';
      return `${monthsText} ב-${this.benefitPercentage}% הנחה${priceText} בנוסף לתקופת הנסיון.`;
    },
    percentageBenefitSignupTimelineText() {
      const monthsText = (this.benefitAmount === 1) ? 'חודש ראשון' : `${this.monthsText}  ראשונים`;
      const priceText = this.discountedPrice ? ` (${this.discountedPrice} ₪)` : '';
      return `בסיום תקופת הנסיון, יהיו לך ${monthsText} ב-${this.benefitPercentage}% הנחה${priceText}.`;
    },
    flavors() {
      return Flavors;
    },
  },
};

</script>
